/* eslint no-tabs: "off", indent: "off" */
import _ from "underscore";

import { adjustStartDateForAggregation } from "lib/helpers/graphHelpers.js";
import { updateDataCompare, updateLowerDataCompare, updateDataByDateCompare, updateGraphDataCompare } from "actions/dataCompare.js";
import { fetchEventCorrelationInit } from "actions/compare.js";
import { RESET_ARTICLES_CURSOR_POS } from "actions/constants.js";

// Set Graph component height
export function setGraphHeightLeft(height) {
	return (dispatch, getState) => {
		const rightHeight = getState().rightCompare.graphHeight;

		dispatch({
			type: "setGraphHeightCompare",
			commonHeight: Math.round((rightHeight > height ? rightHeight : height) * 0.1) * 10,
			leftHeight: height,
		});
	};
}

// Set graph grid height
export function updateGraphSizeLeft(graphSize) {
	return (dispatch, getState) => {
		const { height } = graphSize;
		const rightHeight = getState().rightCompare.graphGridHeight;
		dispatch({
			type: "setGraphSizeCompare",
			tallestHeight: rightHeight > height ? rightHeight : height,
			leftHeight: height,
		});
	};
}

// NOTE: this only works sometimes, because the state hasn't nececarily resolved
export function setCompareHeaderHeightLeft(height) {
	return (dispatch, getState) => {
		const rightHeight = getState().rightCompare.headerHeight;
		dispatch({
			type: "setCompareHeaderHeight",
			commonHeight: rightHeight > height ? rightHeight : height,
			rightHeight: height,
		});
	};
}

export function setSideWidthLeft(width) {
	return {
		type: "setSideWidthLeft",
		width,
	};
}

export function togglePerspectiveLeft() {
	return (dispatch, getState) => {
		const { activeKeywords, activeNarrativeData, perspective } = getState().leftCompare;
		const { location } = getState().router;
		const newPerspective = perspective === "Source" ? "Audience" : "Source";
		const { varStore } = getState().storage;
		const { eventTypes, featuredEventId } = getState().events;

		const eventMode = location && location.pathname === "/events";
		const filtersList = varStore.left[newPerspective].filters;

		// Get correlation if in events mode
		if (eventMode) {
			dispatch(
				fetchEventCorrelationInit({
					primary: activeNarrativeData,
					secondary: _.find(eventTypes, (event) => {
						return event.id === featuredEventId;
					}),
					// Include all events in group - the right side is not updating.
					eventsToFetch: eventTypes,
					activeFilters: filtersList,
				})
			);
		}

		dispatch(
			updateDataCompare({
				side: "Left",
				narrative: activeNarrativeData,
				perspective: newPerspective,
				currentZoom: varStore.left[perspective].currentZoom,
				activeFilters: filtersList,
				entityFilters: newPerspective === "Source" ? varStore.left.Source.entityFilters : [],
				keywords: activeKeywords,
				mapHighlightId: varStore.left[perspective].mapHighlightId,
				contentFilteredByDate: varStore.left[perspective].contentFilteredByDate,
				eventMode,
			})
		);
		dispatch({ type: "togglePerspectiveLeft", perspective: newPerspective, filtersList });
	};
}

export const graphScaleChangeLeft = (scale) => {
	return {
		type: "graphScaleChangeLeft",
		scale,
	};
};

export const toggleEntityFiltersDrawerLeft = () => {
	return (dispatch, getState) => {
		if (getState().leftCompare.entityFiltersOpen) {
			dispatch({ type: "closeEntityFiltersLeft" });
		} else {
			dispatch({ type: "openEntityFiltersLeft" });
		}
	};
};

// Filter content by date (on graph click)
export function filterContentByDateLeft(unit, left) {
	return (dispatch, getState) => {

		const { location } = getState().router;
		const { varStore } = getState().storage;
		const { 
			activeKeywords, 
			activeNarrativeData, 
			aggregationLevel,
			perspective 
		} = getState().leftCompare;

		const moeMode = location && location.pathname === "/moe";
		const eventMode = location && location.pathname === "/events";
		const narType = moeMode ? "leftMOE" : eventMode ? "leftEvent" : "left";

		const adjustedBegin = adjustStartDateForAggregation({ 
			startDate: Number(unit), 
			aggregationLevel,
		});
		const adjustedEnd = Number(unit) + (24 * 60 * 60 * 1000) - 1;

		const contentFilteredByDate = unit
			? {
					begin: adjustedBegin,
					end: adjustedEnd,
					indicatorWidth: 3,
					indicatorOffset: left,
				}
			: false;

		dispatch({ type: "filterContentByDateLeft", contentFilteredByDate });
		dispatch({ type: `${RESET_ARTICLES_CURSOR_POS}_Left` });
		dispatch(
			updateDataByDateCompare({
				narrative: activeNarrativeData,
				perspective,
				currentZoom: varStore[narType][perspective].currentZoom,
				activeFilters: varStore[narType][perspective].filters,
				entityFilters: varStore[narType][perspective].entityFilters,
				keywords: activeKeywords,
				mapHighlightId: varStore[narType][perspective].mapHighlightId,
				contentFilteredByDate,
				narType,
				side: "Left",
				offset: 0,
			})
		);
	};
}
// For updating contentFilteredByDate after window/graph resize
export const formatContentFilteredByDateLeft = (graphSize, trimmedTrendDates) => {
	return {
		type: "formatContentFilteredByDateLeft",
		graphSize,
		trimmedTrendDates,
	};
};

// clears filterContentByDate indicator
export function clearIndicatorLeft() {
	return (dispatch, getState) => {
		const { activeKeywords, activeNarrativeData, perspective } = getState().leftCompare;
		const { varStore } = getState().storage;
		const { location } = getState().router;

		const moeMode = location && location.pathname === "/moe";
		const eventMode = location && location.pathname === "/events";
		const narType = moeMode ? "leftMOE" : eventMode ? "leftEvent" : "left";

		dispatch({ type: `${RESET_ARTICLES_CURSOR_POS}_Left` });
		dispatch(
			updateDataByDateCompare({
				narrative: activeNarrativeData,
				perspective,
				currentZoom: varStore[narType][perspective].currentZoom,
				activeFilters: varStore[narType][perspective].filters,
				entityFilters: varStore[narType][perspective].entityFilters,
				keywords: activeKeywords,
				mapHighlightId: varStore[narType][perspective].mapHighlightId,
				contentFilteredByDate: false,
				narType,
				side: "Left",
				offset: 0,
			})
		);
		dispatch({ type: "clearIndicatorLeft" });
	};
}

export const zoomCompleteLeft = (zoom) => {
	return {
		type: "setCurrentZoomLeft",
		currentZoom: zoom,
	};
};
export const zoomInitLeft = (zoom) => {
	return (dispatch, getState) => {
		const { activeKeywords, activeNarrativeData, perspective } = getState().leftCompare;
		const { varStore } = getState().storage;
		const { location } = getState().router;

		const moeMode = location && location.pathname === "/moe";
		const eventMode = location && location.pathname === "/events";
		const narType = moeMode ? "leftMOE" : eventMode ? "leftEvent" : "left";

		dispatch({ type: `${RESET_ARTICLES_CURSOR_POS}_Left` });
		dispatch(
			updateLowerDataCompare({
				narrative: activeNarrativeData,
				perspective,
				currentZoom: zoom,
				activeFilters: varStore[narType][perspective].filters,
				entityFilters: varStore[narType][perspective].entityFilters,
				keywords: activeKeywords,
				mapHighlightId: varStore[narType][perspective].mapHighlightId,
				contentFilteredByDate: false,
				narType,
				side: "Left",
				offset: 0,
			})
		);
	};
};

export const dataTypeSelectLeft = (dataType) => {
	return (dispatch) => {
		dispatch(updateGraphDataCompare({ dataType, side: "Left" }));
	};
};

// Tooltips
export function closeNarrativeTooltipLeft() {
	return {
		type: "closeNarrativeTooltipLeft",
	};
}
export function openNarrativeTooltipLeft(position, nar) {
	return {
		type: "openNarrativeTooltipLeft",
		position,
		nar,
	};
}

// Header dropdown
export function toggleNarrativeSelectLeft(id, isOpen) {
	return {
		type: isOpen ? "closeNarrativeSelectLeft" : "openNarrativeSelectLeft",
	};
}
export function closeNarrativeSelectLeft() {
	return {
		type: "closeNarrativeSelectLeft",
	};
}
export function setNarrativeSelectLeft(narrative) {
	return (dispatch, getState) => {
		dispatch({
			type: "setNarrativeSelectLeft",
			narrative,
			compareMultiSelect: getState().projectConfig.compareMultiSelect,
		});
	};
}
export function toggleNarrativeFiltersLeft(id, isOpen) {
	return {
		type: isOpen ? "closeNarrativeFiltersLeft" : "openNarrativeFiltersLeft",
	};
}
export function closeNarrativeFiltersLeft() {
	return {
		type: "closeNarrativeFiltersLeft",
	};
}
export function setNarrativeFiltersLeft(params) {
	return {
		type: "setNarrativeFiltersLeft",
		params,
	};
}
